import React from "react";
import {
  NavLink,
  Link
} from "react-router-dom";

import Modal from './../../../components/modal.js';
import logo from './../../../images/logo.png';

class Head extends React.Component {
  constructor(props) {
    super(props);
    let user = {};
    let logo = '';
    let companyname = '';
    if (typeof localStorage.token !== 'undefined' && localStorage.token !== '') {
      user = JSON.parse(localStorage.user);
      logo = user.company.logo || '';
      companyname = user.company.name || '';
    }

    this.state = {
      logout: (typeof localStorage.token !== 'undefined' && localStorage.token !== '') ? true : false,
      title: '登出提醒',
      display: false,
      user: user,
      logo: logo,
      companyname: companyname
    };

    this.close = this.close.bind(this);
    this.submit = this.submit.bind(this);
    this.modal = this.modal.bind(this);
  }

  componentDidMount() {

  }


  componentWillReceiveProps(nextProps) {}

  close() {
    this.setState({
      display: false
    });
  }

  submit() {
    localStorage.clear();
    this.setState({
      display: false
    });
    this.props.parent.history.push('/');
  }
  modal() {
    this.setState({
      display: true
    });
  }

  render() {
    const {
      logo,
      companyname
    } = this.state;
    return (
      <div style={{ display: this.props.partstyle ? 'none' : 'block' }}>
        <nav className="navbar navbar-dark fixed-top bg-dark flex-md-nowrap p-0 shadow consoleheader">
          <NavLink className="navbar-brand col-sm-3 col-md-2 mr-0 text-center" to="/"> {logo == '' ? <span> {companyname} </span> : <span><img src={logo} className="logo" alt="" /></span>}</NavLink>
          <span className="text-muted"></span>
          <nav className="nav nav-masthead justify-content-center">
            <Link className="nav-link text-white-50 " to="/console/user/user_profile">
              <i className="fa fa-user"></i>  {this.state.user.username || this.state.user.realname || this.state.user.email}</Link>
            <a className="nav-link text-white-50 " onClick={this.modal}> <i className="fa fa-sign-out-alt"></i> 登出</a>
          </nav>

        </nav>
        <Modal title={this.state.title} display={this.state.display} close={this.close} submit={this.submit}>
          <span>确认要退出当前登录吗？</span>
        </Modal>
      </div>
    );
  }
}

export default Head


// WEBPACK FOOTER //
// ./src/apps/console/common/head.js